import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import AdminPageLayout from '../../layout/admin-page-layout';
import { EditableArcGISMap } from '../_shared/components/arcgis-map';
const AdminGeometryEditor = () => (_jsx(AdminPageLayout, { children: _jsx(EditableArcGISMap, {}) }));
export default AdminGeometryEditor;
